import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import actionTypes from 'constants/actionTypes';

import Button from 'modules/_shared/components/Buttons';

import { usePublishTradingOfferModal } from '../context/PublishTradingOfferModalContext';

const PublishTradingOfferModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = usePublishTradingOfferModal();

  const buttonLabel =
    data.modalActionType === actionTypes.EDIT
      ? t('EditOffer')
      : t('ConfirmAndPublishOffer');

  const isReadOnlyView = data.modalActionType === actionTypes.VIEW;

  return (
    <>
      {!isReadOnlyView && (
        <Modal.Footer className="d-flex justify-content-between">
          <button
            type="button"
            className="btn btn-outline-light"
            onClick={actions.handleCloseModal}
          >
            {t('Cancel')}
          </button>
          <Button
            onClick={actions.handlePublishTradingOffer}
            disabled={!data.isTermsAndConditionsAccepted}
            lgSize
          >
            {buttonLabel}
          </Button>
        </Modal.Footer>
      )}
    </>
  );
};

export default PublishTradingOfferModalFooter;
